import { ToastContainer, toast } from "react-toastify";
import Loader from "../components/Loader";
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Rightarrow from "../assets/icons/Rightarrow";
import { Link } from "react-router-dom";
import { postWithImage } from "../network/api";
import { useTranslation } from "react-i18next"; 
const DeliveryPartner = () => {
  const { t } = useTranslation();
  const [idFrontFile, setIdFrontFile] = useState(null);
  const [idBackFile, setIdBackFile] = useState(null);
  const [personPhoto, setPersonPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  

  const handleFileChange = (e, setFile, field) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      formik.setFieldValue(field, file);
    }
  };

  const handleRemoveFile = (setFile, field) => {
    setFile(null);
    formik.setFieldValue(field, null);
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("mobile_number", values.phone);
    formData.append("language", values.language);
    formData.append("email", values.email);
    formData.append("mobile_country_code", '63');
    
    formData.append("id_number", values.idNumber);
    formData.append("id_proof_front", values.idFront);
    formData.append("id_proof_back", values.idBack);
    formData.append("profile", values.personPhoto);
    setLoading(true);
    try {
      const data = await postWithImage("customer/create-driver", formData);
      setLoading(false);
      toast.success("Request Sent! Loadinn will get back to you", {
        position: "bottom-center",
        autoClose: 3000,
      });
    } catch (error) {
      setLoading(false);
      toast.error(error.toString(), {
        position: "bottom-center",
        autoClose: 3000,
      });
      console.error("Error registering driver", error);
      // Handle error (e.g., show error message)
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      language: "",
      email: "",
      idNumber: "",
      idFront: null,
      idBack: null,
      personPhoto: null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      phone: Yup.string()
        .matches(/^\+?\d{10,15}$/, "Enter a valid phone number")
        .required("Phone number is required"),
      language: Yup.string().required("Language is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      idNumber: Yup.string().required("ID number is required"),
      idFront: Yup.mixed().required("Front ID photo is required"),
      idBack: Yup.mixed().required("Back ID photo is required"),
      personPhoto: Yup.mixed().required("Person photo is required"),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <div>
      <ToastContainer />
      <section className="dlr_section">
        <div className="wrapper">
          <div className="title_group">
            <h2 className="subtitle_common">
              {t("become_a")} <span className="text-primary">{t("delivery_partner")}</span>
            </h2>
            <p className="para_common">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>
          <form onSubmit={formik.handleSubmit} className="card">
            <h3 className="card_title">{t("delivery_partner_details")}</h3>
            <div className="form_grid">
              <div className="form_group">
                <label htmlFor="name">{t("name")}*</label>
                <input
                  type="text"
                  id="name"
                  {...formik.getFieldProps("name")}
                  placeholder={t("enter_your_name_here")}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="error">{formik.errors.name}</div>
                )}
              </div>
              <div className="form_group">
                <label htmlFor="phone">{t("phone_number")}*</label>
                <input
                  type="tel"
                  id="phone"
                  {...formik.getFieldProps("phone")}
                  placeholder="00000 00000"
                />
                {formik.touched.phone && formik.errors.phone && (
                  <div className="error">{formik.errors.phone}</div>
                )}
              </div>
              <div className="form_group">
                <label htmlFor="language">{t("language")}*</label>
                <input
                  type="text"
                  id="language"
                  {...formik.getFieldProps("language")}
                  placeholder="Enter your language here"
                />
                {formik.touched.language && formik.errors.language && (
                  <div className="error">{formik.errors.language}</div>
                )}
              </div>
              <div className="form_group">
                <label>Live photo of ID (Front & Back)*</label>
                <div className="upload_group">
                  <div className="file_input_wrapper">
                    <input
                      type="file"
                      id="idFront"
                      onChange={(e) =>
                        handleFileChange(e, setIdFrontFile, "idFront")
                      }
                      className="file_input"
                    />
                    <label htmlFor="idFront" className="upload_btn">
                      {idFrontFile ? idFrontFile.name : "Upload Front"}
                    </label>
                    {idFrontFile && (
                      <span
                        className="remove_icon"
                        onClick={() =>
                          handleRemoveFile(setIdFrontFile, "idFront")
                        }
                      >
                        &#10005;
                      </span>
                    )}
                    {formik.touched.idFront && formik.errors.idFront && (
                      <div className="error">{formik.errors.idFront}</div>
                    )}
                  </div>
                  <div className="file_input_wrapper">
                    <input
                      type="file"
                      id="idBack"
                      onChange={(e) =>
                        handleFileChange(e, setIdBackFile, "idBack")
                      }
                      className="file_input"
                    />
                    <label htmlFor="idBack" className="upload_btn">
                      {idBackFile ? idBackFile.name : "Upload Back"}
                    </label>
                    {idBackFile && (
                      <span
                        className="remove_icon"
                        onClick={() =>
                          handleRemoveFile(setIdBackFile, "idBack")
                        }
                      >
                        &#10005;
                      </span>
                    )}
                    {formik.touched.idBack && formik.errors.idBack && (
                      <div className="error">{formik.errors.idBack}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form_group">
                <label htmlFor="email">Email*</label>
                <input
                  type="email"
                  id="email"
                  {...formik.getFieldProps("email")}
                  placeholder="Enter your email here"
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error">{formik.errors.email}</div>
                )}
              </div>
              <div className="form_group">
                <label htmlFor="idNumber">ID Number*</label>
                <input
                  type="text"
                  id="idNumber"
                  {...formik.getFieldProps("idNumber")}
                  placeholder="Enter your ID number here"
                />
                {formik.touched.idNumber && formik.errors.idNumber && (
                  <div className="error">{formik.errors.idNumber}</div>
                )}
              </div>
              <div className="form_group">
                <label>Live photo of Person*</label>
                <div className="file_input_wrapper">
                  <input
                    type="file"
                    id="personPhoto"
                    onChange={(e) =>
                      handleFileChange(e, setPersonPhoto, "personPhoto")
                    }
                    className="file_input"
                  />
                  <label htmlFor="personPhoto" className="upload_btn">
                    {personPhoto ? personPhoto.name : "Upload Photo"}
                  </label>
                  {personPhoto && (
                    <span
                      className="remove_icon"
                      onClick={() =>
                        handleRemoveFile(setPersonPhoto, "personPhoto")
                      }
                    >
                      &#10005;
                    </span>
                  )}
                  {formik.touched.personPhoto && formik.errors.personPhoto && (
                    <div className="error">{formik.errors.personPhoto}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="continue_button">
              <p>
                LoadInn may disclose the information provided by you, including
                but not limited to the contact number and email address of the
                authorised persons, with third party service providers for
                provision of LoadInn services.
              </p>
              <button type="submit" className="btn btn-primary">
                Continue <Rightarrow />
              </button>
            </div>
          </form>
        </div>
      </section>
      {loading && <Loader />}
      
    </div>
  );
};

export default DeliveryPartner;
